import styled from 'styled-components';
import { GridStyled } from '../GridStyled';
import media from '../../../styles/media';

export const GridStyledAP = styled(GridStyled)``;
